import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnestBoldDefault } from "../../styled/TextComponents";
import { getGameTilePreviewUrl } from "./gamesUtils";
import {
  getTileImageStyle,
  tileContainerStyle,
  tileTitleStyle,
} from "./gamesStyles";
import { useI18n } from "../../../i18n/I18nProvider";

const GameCoverTile = ({ game }) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  if (!game) return null;

  return (
    <div
      onClick={() => {
        if (game.link) navigate(game.link);
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      style={tileContainerStyle}
    >
      <img
        style={getTileImageStyle({ hovered, pressed })}
        src={getGameTilePreviewUrl(game)}
        alt={t(game.name)}
      />
      <OnestBoldDefault style={tileTitleStyle}>{t(game.name)}</OnestBoldDefault>
    </div>
  );
};

export default GameCoverTile;
